"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var ConfigContext_1 = require("../contexts/ConfigContext");
var utils_1 = require("../libs/utils");
var ChangelogPreview_1 = require("./ChangelogPreview");
var Changelogs = function (props) {
    var data = props.data, toggleStage = props.toggleStage, loading = props.loading, error = props.error;
    var translations = hooks_1.useContext(ConfigContext_1.default).translations;
    var handleClick = function (stage, stageProps) {
        utils_1.addChangelogToViewed(stageProps.id);
        return toggleStage(stage, stageProps);
    };
    var renderChangelog = function (changelog, index) {
        return (preact_1.h("div", { key: index, onClick: function () { return handleClick(2, { id: changelog.id.toString() }); } },
            preact_1.h(ChangelogPreview_1.default, { key: index, changelog: changelog })));
    };
    var renderChangelogs = function () {
        if (data && data.changelogs && data.changelogs.length)
            return data.changelogs.map(renderChangelog);
    };
    if (!data && loading) {
        return (preact_1.h("div", { className: "flex items-center justify-center h-full" },
            preact_1.h("svg", { class: "animate-spin h-5 w-5 text-primary", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" },
                preact_1.h("circle", { class: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", "stroke-width": "4" }),
                preact_1.h("path", { class: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" }))));
    }
    if (error)
        return preact_1.h("div", { className: "my-10 text-center text-red-700" }, error);
    if (data && data.changelogs) {
        if (!data.changelogs.length) {
            return (preact_1.h("div", { className: "flex flex-col items-center justify-center h-full text-gray-600 w-2/4 mx-auto" },
                preact_1.h("div", { dangerouslySetInnerHTML: { __html: data.empty_svg } }),
                preact_1.h("p", { className: "text-sm" }, translations.changelogEmptyText)));
        }
        return preact_1.h(preact_1.Fragment, null, renderChangelogs());
    }
};
exports.default = Changelogs;
